export default function isPastDate(value, hours = 0) {
  const date = new Date(value);
  date.setHours(date.getHours() + hours);

  return date < new Date();
}
